import {
  GET_DELIVERY_AREAS,
  GET_DELIVERY_AREAS_REQUEST_ERROR,
  GET_DELIVERY_AREAS_REQUEST_PENDING,
  GET_DELIVERY_AREAS_REQUEST_SUCCESS,
} from '../types/deliveryAreas'

const initialState = {
  items: [],
  pagination: {
    current: 1,
    pageSize: 20,
  },
  isGetLoading: false,
  errors: [],
}

const deliveryAreas = (state = initialState, action) => {
  switch (action.type) {
    case GET_DELIVERY_AREAS:
      return { ...state, ...action.payload }
    case GET_DELIVERY_AREAS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_DELIVERY_AREAS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_DELIVERY_AREAS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    default:
      return state
  }
}

export default deliveryAreas

